// extracted by mini-css-extract-plugin
export default {"paymentStatus":"Payouts_paymentStatus__Mxyym","payoutsDisabled":"Payouts_payoutsDisabled__KjF+A","exchangeRateNotSet":"Payouts_exchangeRateNotSet__rbJNo"};